import React, { useState } from 'react';
import classNames from 'classnames';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

import { fontWeightEnum, Text, textVariantsEnum } from '@components/Text';

import styles from './PhoneInput.module.scss';

export const PhoneInputComponent = ({
  id,
  label,
  labelConfig = {},
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  hasError,
  errorMessage,
  successMessage,
  className,
  style,
  numberInputProps,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const rootClass = classNames(
    styles.input,
    {
      [styles.input_focused]: isFocused,
      [styles.input_error]: !!errorMessage || hasError,
      [styles.input_disabled]: disabled,
    },
    className
  );

  const handleChange = (nextValue) => {
    if (onChange) {
      onChange(nextValue);
    }
  };

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  return (
    <div className={rootClass} style={style}>
      {!!label && (
        <Text
          variant={labelConfig.variant || textVariantsEnum.Text_sm}
          fontWeight={labelConfig.fontWeight || fontWeightEnum.Normal}
          color="gray-700"
          className={styles.inputLabel}
        >
          {label}
        </Text>
      )}
      <div className={styles.inputContainer}>
        <section>
          <PhoneInput
            {...rest}
            id={id}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            disabled={disabled}
            onFocus={handleFocus}
            onBlur={handleBlur}
            className={styles.phoneInput}
            numberInputProps={{
              ...numberInputProps,
              className: classNames(
                styles.phoneInputField,
                numberInputProps?.className
              ),
            }}
          />
        </section>
      </div>
      {!!errorMessage && (
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Regular}
          color="error-500"
          className={styles.errorMessage}
        >
          {errorMessage}
        </Text>
      )}
      {!!successMessage && !errorMessage && (
        <Text
          variant={textVariantsEnum.Text_sm}
          color="success-700"
          className={styles.successMessage}
        >
          {successMessage}
        </Text>
      )}
    </div>
  );
};

PhoneInputComponent.displayName = 'PhoneInput';
